import Icon, { type IconString } from '2-core-elements/Icon/Icon';

export type BadgeProps = {
    label: string;
    skin?: 'primary' | 'neutral' | 'success' | 'error' | 'warning' | 'info';
    variant?: 'bold' | 'subtle' | 'outline';
    size?: 'sm' | 'md' | 'lg';
    prefixIcon?: IconString;
};

const Badge = ({ skin = 'primary', variant = 'bold', label, size = 'md', prefixIcon }: BadgeProps): JSX.Element => {
    return (
        <div className={`badge badge-${skin} badge-${variant} badge-${size}`}>
            {prefixIcon && <Icon icon={prefixIcon} />}
            {label}
        </div>
    );
};

export default Badge;
